module.exports = __webpack_public_path__ + "static/img/logo.57dc0fca.png";